import { render, staticRenderFns } from "./line_item.vue?vue&type=template&id=18455ad7&scoped=true&"
import script from "./line_item.vue?vue&type=script&lang=js&"
export * from "./line_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18455ad7",
  null
  
)

export default component.exports